import { useState, useEffect, useCallback } from "react";

export function useFetch<T>(fetcher: () => Promise<T>, deps: unknown[] = []) {
	const [data, setData] = useState<T | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	const refetch = useCallback(() => {
		setLoading(true);
		setError(null);
		fetcher()
			.then(setData)
			.catch((e) => setError(e.message))
			.finally(() => setLoading(false));
	}, deps);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { data, loading, error, refetch };
}

export function useRoute() {
	const [path, setPath] = useState(window.location.hash.slice(1) || "/");

	useEffect(() => {
		const handler = () => setPath(window.location.hash.slice(1) || "/");
		window.addEventListener("hashchange", handler);
		return () => window.removeEventListener("hashchange", handler);
	}, []);

	const navigate = (to: string) => {
		window.location.hash = to;
	};

	return { path, navigate };
}
